import { Component, inject } from "@angular/core";
import { TranslateService, TranslateModule } from "@ngx-translate/core";
import { ButtonComponent } from "@app/kernel/shared/modules/button/components/button/button.component";
import { CommonModule } from "@angular/common";
import { SxwFormComponent } from "@app/kernel/form/components/sxw-form/sxw-form.component";
import { UpdatePasswordFormComponent } from "../../components/update-password-form/update-password-form.component";
import { UpdatePasswordFormModel } from "../../models/password-form.model";
import { ProfileService } from "../../../../services/profile.service";
import { SideDialogComponent } from "@app/kernel/popups/popups.config";
import { Router } from "@angular/router";

@Component({
  selector: "app-update-password",
  standalone: true,
  imports: [UpdatePasswordFormComponent, ButtonComponent, SxwFormComponent, CommonModule, TranslateModule, SideDialogComponent],
  templateUrl: "./update-password.component.html",
  styleUrls: ["./update-password.component.scss"],
  providers: [UpdatePasswordFormModel],
})
export class UpdatePasswordComponent {
  readonly formModel = inject(UpdatePasswordFormModel);
  private readonly translate = inject(TranslateService);
  private readonly ProfileService = inject(ProfileService);
  private router = inject(Router);
  isLoading = false;
  isDialogVisible = true;

  submit() {
    if (this.formModel.formStatus() !== "VALID") {
      this.formModel.formGroup().markAllAsTouched();
      return;
    }
    this.isLoading = true;
    const dto = this.formModel.getDtoForBackend();
    this.ProfileService.updateMyPassword(dto).subscribe({
      next: async () => {
        this.isDialogVisible = false;
        this.router.navigate(["/profile"]);
      },
      error: () => {
        this.isLoading = false;
      },
      complete: () => {
        this.isLoading = false;
      },
    });
  }
  hideDialog() {
    console.log("Dialog closed");
  }
}
